import { AwsUi } from '../../../core/runtime/src';
import LegacyClassBuilder from '../../../core/utils/src/class-builders/legacy';
export var Badge = AwsUi.__addComponent('awsui-badge', {
    releaseStatus: 'stable',
    properties: {
        // Indicates the badge color.
        color: {
            type: 'string',
            valid: ['blue', 'grey', 'green', 'red'],
            defaultValue: 'grey'
        }
    },
    regions: {
        // Text displayed inside the badge.
        content: {
            isDefault: true
        }
    },
    render: function (m, h) {
        var classes = new LegacyClassBuilder(this);
        classes.addClass('awsui-badge-content');
        classes.addPropertyValueClass('color');
        return AwsUi.__createElement("span", { className: classes.toClassName() }, h.region('content'));
    }
});
//# sourceMappingURL=index.js.map